// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LocalLoader_wrapper__3cvTJ","loading":"LocalLoader_loading__zervv","counter":"LocalLoader_counter__F43ZF"};